var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u97F3\u9891") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.358,0 L32,8.026 L32,35.45408 C32,36.8601528 30.8601528,38 29.45408,38 L2.54592,38 C1.13984721,38 1.72194254e-16,36.8601528 0,35.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,-1.07397625e-15 2.54592,0 L24.358,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u97F3\\u9891",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7B7FEB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C7C9FE",
    mask: "url(#mask-2)",
    x: 24,
    y: -6.55172414,
    width: 12,
    height: 14.4137931,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.7687329,13.8828923 C21.992584,14.4698766 20.9990649,14.8409186 19.9125535,14.8409186 C18.9812234,14.8409186 17.6771477,14.1918364 17.3978311,13.6356114 L17.3978311,23.8339081 C17.4597775,25.533584 16.2180848,27.2025489 14.2932356,27.7897264 C12.0578298,28.4695195 9.76047766,27.4496367 9.13951005,25.4719207 C8.5496369,23.5249639 9.88456447,21.3925344 12.1199703,20.7125482 C13.0513489,20.4345563 14.013725,20.4345563 14.8209683,20.7125482 C15.03829,20.7744529 15.2556602,20.6199325 15.2556602,20.403604 L15.2556602,10.050642 C15.2556602,9.77260189 15.3797955,9.49436864 15.5660228,9.30894418 C15.7522985,9.12351973 16.0318091,9 16.3111257,9 C16.7458176,9 17.1183205,9.24728089 17.2735503,9.6181298 L17.2735503,9.58717744 L17.2735503,9.6181298 C17.2735503,9.64884073 17.2735503,9.64884073 17.3045962,9.67979309 C17.9255639,11.5341342 19.6951833,12.8630095 21.7441678,12.8630095 C21.9304436,12.8630095 22.1166708,12.8630095 22.3029465,12.8320571 C22.9550086,12.7702007 23.2344707,13.5428026 22.7687329,13.8828923 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.9cafa94a5fb4eeacdc32cabb7631040c.svg";
export { ForwardRef as ReactComponent };